import React, { useContext } from 'react'

import { compose, withProps } from 'recompose'

import InvestAccordion from 'assets/icons/invest-interstitial.svg'
import Button from 'components/Button'
import { CTAContainer } from 'components/CTAContainer'
import withHeroText, { HeroTextProps } from 'components/HOCs/withHeroText'
import withRemoteStrings, { RemoteStringsProps } from 'components/HOCs/withRemoteStrings'
import Layout from 'components/Layout'
import { Nav } from 'components/Nav'
import Separator from 'components/Separator'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { ActionType, PageName } from 'generated/types'
import { TestIDs } from 'test/utils/testIds'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { FunnelContext } from 'utils/FunnelContext'
import withTieredRegistration, { WithTieredRegistrationProps } from 'utils/TieredRegistration'

import {
  BodyContainer,
  ContentContainer,
  FooterContainer,
  Image,
  StyledBody,
  StyledTitle,
} from './styled-components'

type Props = {
  handleNextClick: () => void
  text: string
  header: string
  disclaimer: string
  ctaLabel: string
  footnote: string
} & HeroTextProps &
  RemoteStringsProps &
  WithTieredRegistrationProps &
  WithFlowRouterProps

const NextButton = withClickTrack<any, any>(TRACKER_IDS.INVEST_INTERSTITIAL.NEXT_BUTTON)(Button)

const enhance = compose<Props, {}>(
  withFlowRouter,
  withHeroText,
  withRemoteStrings,
  withTieredRegistration,
  withProps(({ heroText, getRemoteString }) => ({
    header: getRemoteString('invest_interstitial_header', heroText.header),
    text: heroText.text,
    ctaLabel: getRemoteString('invest_interstitial_cta_label', heroText.ctaLabel),
    footnote: heroText.footnote,
  })),
)
const InvestInterstitial: React.FC<Props> = ({ ctaLabel, header, text, footnote, route }) => {
  const { isBackEnabled, isDynamicFunnelEnabled, routeToPage } = useContext(FunnelContext)

  const handleNextClick = () => {
    isDynamicFunnelEnabled
      ? routeToPage(PageName.InvestInterstitial, ActionType.Continue)
      : route({ from: FlowRoute.InvestInterstitial, action: 'continue' })
  }

  return (
    <>
      <Nav back={isDynamicFunnelEnabled && isBackEnabled(PageName.InvestInterstitial)} />
      <Layout>
        <ContentContainer>
          <Image
            src={InvestAccordion}
            alt={'invest interstitial accordion'}
            data-testid={TestIDs.INVEST_INTERSTITIAL.IMAGE}
          />
          <BodyContainer>
            <StyledTitle>{header}</StyledTitle>
            <StyledBody>{text}</StyledBody>
          </BodyContainer>
        </ContentContainer>
        <Separator />
        <CTAContainer>
          <FooterContainer>
            <i>{footnote}</i>
          </FooterContainer>
          <NextButton
            data-testid={TestIDs.INVEST_INTERSTITIAL.NEXT_BUTTON}
            onPress={handleNextClick}
          >
            {ctaLabel}
          </NextButton>
        </CTAContainer>
      </Layout>
    </>
  )
}

export default enhance(InvestInterstitial)
